'use client';
import { useEffect } from 'react';
import { track } from '@vercel/analytics';

// Every call to action on the site leaves it (demo booking, docs, xronos.ai,
// GitHub), so page views alone can't tell a click-through from a bounce.
// Record outbound link clicks as a custom event instead.
export function OutboundLinkTracker() {
  useEffect(() => {
    function onClick(event: MouseEvent) {
      const link = (event.target as Element | null)?.closest?.('a[href]');
      if (!(link instanceof HTMLAnchorElement)) return;

      const url = new URL(link.href, window.location.href);
      const isMail = url.protocol === 'mailto:';
      const isExternal =
        (url.protocol === 'http:' || url.protocol === 'https:') &&
        url.host !== window.location.host;
      if (!isMail && !isExternal) return;

      track('Outbound Click', {
        // Drop the query string: share links carry the full referral URL.
        destination: isMail ? 'mailto' : url.host + url.pathname,
        label: (link.getAttribute('aria-label') ?? link.textContent ?? '').trim().slice(0, 100),
        page: window.location.pathname,
      });
    }

    document.addEventListener('click', onClick, { capture: true });
    return () => document.removeEventListener('click', onClick, { capture: true });
  }, []);

  return null;
}
